import apiRequest from './wrapper';

/**
 * @method : GET
 * @path   : /calendar/availability
 * @desc   : get available time slots for a specific date
 */
export const getCalendarAvailability = (date) => {
  return new Promise((resolve, reject) => {
    apiRequest('get', '/calendar/availability', { params: date ? { selected_date: date } : null })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          const { status, data } = error.response;
          let errorMessage;

          if (status === 401) {
            // handle unauthorized error
            errorMessage = 'getCalendarAvailability: You are not authorized to perform this action';
          } else if (status === 404) {
            // handle not found error
            errorMessage = 'getCalendarAvailability: The resource you are trying to access was not found';
          } else if (status >= 500) {
            // handle server error
            errorMessage = 'getCalendarAvailability: An error occurred on the server';
          } else {
            errorMessage = data.message;
          }

          reject(new Error(errorMessage));
        } else if (error.request) {
          // The request was made but no response was received
          reject(new Error('getCalendarAvailability: No response was received from the server'));
        } else {
          // Something happened in setting up the request that triggered an Error
          reject(error);
        }
      });
  });
};

/**
 * @method : POST
 * @path   : /calendar/book
 * @desc   : book an appointment for a specific date and time
 */
export const bookAppointment = (appointmentData) => {
  return new Promise((resolve, reject) => {
    apiRequest('post', '/calendar/schedule', { data: appointmentData })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          const { status, data } = error.response;
          let errorMessage;

          if (status === 401) {
            errorMessage = 'bookAppointment: You are not authorized to perform this action';
          } else if (status === 404) {
            errorMessage = 'bookAppointment: The resource you are trying to access was not found';
          } else if (status === 409) {
            errorMessage = 'bookAppointment: This time slot is no longer available';
          } else if (status >= 500) {
            errorMessage = 'bookAppointment: An error occurred on the server';
          } else {
            errorMessage = data?.detail?.message || data?.message || 'An unknown error occurred';
          }

          const enrichedError = new Error(errorMessage);
          enrichedError.status = status; // e.g. 400
          enrichedError.code = data?.detail?.code; // e.g. 2001
          enrichedError.data = data; // full body if needed
          reject(enrichedError);
        } else if (error.request) {
          reject(new Error('bookAppointment: No response was received from the server'));
        } else {
          reject(error);
        }
      });
  });
};
